import React, {useState, useEffect} from 'react';
import { useNavigate, Link } from 'react-router-dom';
import '../styles/global.css';
import axios from 'axios';
import { CircularProgress } from '@mui/material';
import Prestacao from './Forms/Prestacao';
import './Calendar/Calendar.css';
import Calendar from './Calendar/Calendar';
import MenuAssociados from '../components/MenuAssociados';
//import ViewPDF from './ViewPDF';

function Prestacoes() {

    const [prestacoes, setPrestacoes] = useState([]);
    const [modalInfo, setModalInfo] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectStatus, setSelectStatus] = useState('');
    const [isLoadingMOD, setIsLoadingMOD] = useState(false);

    const [menuAberto, setMenuAberto] = useState(false);
    const associado = parseInt(sessionStorage.getItem('pesAssociado'));
    //era localStorage.getItem('pesAssociado') mas estava dando problema de atualização do valor, então mudei para sessionStorage que atualiza normalmente
    const navigate = useNavigate();
    const loggedIn = sessionStorage.getItem('loggedIn');
    //era localStorage.getItem('loggedIn') mas estava dando problema de atualização do valor, então mudei para sessionStorage que atualiza normalmente
    
    useEffect(() => {
        if (loggedIn === false || loggedIn === null || loggedIn === undefined)
        {
            navigate('/Login');
            window.location.reload();
        }
        }, []);

    useEffect(() => {
        var token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
        setIsLoadingMOD(true);
        axios
            .get(
                process.env.REACT_APP_API_URL +
                '/routes.php?metodo=obtemTodasPrestacoes',
                {
                    headers: {
                        "X-Access-Token": token,
                        "Content-Type": "application/json; charset=UTF-8"
                    }
                }
            )
            .then(response => {
                setPrestacoes(response.data);
                setIsLoadingMOD(false)
            })
            .catch(error => {
                let ret = error.message;
                setIsLoadingMOD(false);
                if (ret.includes("401")) {
                    console.log("token inválido!")
                }
                else if (ret.includes("403")) {
                    //window.location.reload();
                }
            })
    },[])

    function handleSelectStatusChange(event) {
        sessionStorage.selectStatusRegistro = event.target.value
        setSelectStatus(sessionStorage.selectStatusRegistro)
    }

    function handleNovoCadastro() {
        //setModalOpen(false);
    }

    function handleEditCadastro(prestacao) {
        // setModalInfo(prestacao);
        // setModalOpen(true);
        //console.log(prestacao); return;
        navigate(`/Prestacao`, { state: { registro: prestacao } });
        //window.location.reload();
    }

    function handleExibirPDF(prestacao) {
        //console.log(prestacao);
        //return;
        navigate(`/ViewPDF`, { state: { registro: prestacao } });
    }

    const toggleMenu = () => {
        setMenuAberto(!menuAberto);
    };

    const toggleLogoff = () => {
    localStorage.clear();
    localStorage.setItem('loggedIn', false);
    localStorage.removeItem('user');
    sessionStorage.clear();
    
    navigate('/');
    window.location.reload();
    }


  //salvar log de navegação
  useEffect(() => {
    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const log = {
      IdPessoa: sessionStorage.IdPessoa ? sessionStorage.IdPessoa : 0,
      logTipo: "Navegação",
      logModulo: "Página de Prestações",
      logCriadoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : "Visitante",
      logCriadoEm: new Date().toISOString(),
      logCodigoGUID: crypto.randomUUID()
    };
    axios                    
      .post(process.env.REACT_APP_API_URL 
          + '/routes.php?metodo=novoLog', 
          log, {
              headers: {
                  "X-Access-Token" : tokenAPI,
                  "Content-Type": "application/json; charset=UTF-8"
              }
          }
      )
      .then(response => {
          //console.log(response.data[0].mensagem);
      })
      .catch(error => {
          console.error('Erro ao enviar log:', error);
      });
  }, []);

  //identificar a resolução da tela para ajustar o tamanho da tabela
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  
    useEffect(() => {
      const handleResize = () => {
        setWindowWidth(window.innerWidth);
      };
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

    return (
        <div style={{ paddingBottom: '80px' }}>
            <main>
                <div>
                    {/* Menu de navegação */}
                    <div>
                        <MenuAssociados />
                    </div>
                    {/* Titulos da página */}
                    <div className='headerMain'>
                        <label className='labelTitulo' >FINANCEIRO</label>
                        <label className='labelSubTitulo'>Prestação de contas</label>
                    </div>
                    
                    {/* <div>
                        {modalOpen && (<Prestacao setOpenModal={setModalOpen} prestacaoInfo={modalInfo} />)}
                    </div> */}

                    {/* Pesquisa filtro e Novo */}
                    <div className="containerBarraPesquisa">
                        
                        {parseInt(sessionStorage.pesAdmin) === 1 ? (
                        // <Link to="/Prestacao">
                            <button className="buttonModalPadrao" onClick={() => navigate(`/Prestacao`)}>
                                NOVO REGISTRO
                            </button>
                        // </Link> 
                        ) : ('')}

                        <input className="inputBarraPesquisa"
                        placeholder="PESQUISAR"
                        type="text"
                        id="inputPesquisa"
                        name="inputPesquisa"
                        onChange={event => {
                            setSearchTerm(event.target.value)
                        }}
                        />
                        {parseInt(sessionStorage.pesAdmin) === 1 ? (
                        <select className="selectStatusPesquisa"
                        name="SelectStatusRegistro"
                        selected={sessionStorage.selectStatusRegistro !== undefined ? sessionStorage.selectStatusRegistro : '99'}
                        onChange={event => {
                            handleSelectStatusChange(event)
                        }}
                        >
                        <option value={'99'} selected={sessionStorage.selectStatusRegistro === '99'} >TODOS</option>
                        <option value={'1'} selected={sessionStorage.selectStatusRegistro === '1'} >ATIVOS</option>
                        <option value={'0'} selected={sessionStorage.selectStatusRegistro === '0'} >INATIVOS</option>
                        </select>
                        ) : ('')}
                    </div>

                </div>

                {/* Tabela de prestações */}
                <div className="tabelaPadrao">
                    {windowWidth < 769 ?
                        isLoadingMOD ? <tr><td colSpan="5" style={{ width: "100%", textAlign: "center"}}><CircularProgress /></td></tr> :  
                        prestacoes
                        .filter(val => {
                            if (searchTerm === '') {
                                if(sessionStorage.selectStatusRegistro !== undefined && sessionStorage.selectStatusRegistro === '99')
                                {
                                    return val
                                }
                                else if (sessionStorage.selectStatusRegistro !== undefined && sessionStorage.selectStatusRegistro !== '99')
                                {
                                    if(parseInt(sessionStorage.selectStatusRegistro) === parseInt(val.pdcStatus))
                                    {
                                    return val
                                    }
                                }
                                else{
                                    return val
                                }
                            } 
                            else if (
                                val.pdcMes
                                .toLowerCase()
                                .includes(searchTerm.toLowerCase())
                                ||
                                val.pdcAno
                                .toLowerCase()
                                .includes(searchTerm.toLowerCase())
                                ||
                                val.pdcObservacoes
                                .toLowerCase()
                                .includes(searchTerm.toLowerCase())
                                ||
                                val.pdcMesAno
                                .toLowerCase()
                                .includes(searchTerm.toLowerCase())
                            ) {
                                if(sessionStorage.selectStatusRegistro !== undefined && sessionStorage.selectStatusRegistro === '99')
                                {
                                    return val
                                }
                                else if (sessionStorage.selectStatusRegistro !== undefined && sessionStorage.selectStatusRegistro !== '99')
                                {
                                    if(parseInt(sessionStorage.selectStatusRegistro) === parseInt(val.pdcStatus))
                                    {
                                    return val
                                    }
                                }
                                else{
                                    return val
                                }
                            }
                        })
                        .map(prestacao => (
                            <div key={prestacao.IdPrestacaoDeContas} 
                                className="p2" 
                                onClick={() => handleEditCadastro(prestacao)}
                                style={{ cursor: 'pointer', borderBottom: '1px solid #ccc', margin: '10px', backgroundColor: '#dfdada', borderRadius: '5px', padding: '10px' }}
                                >
                                <p style={{ color: '#000' }}><strong>MÊS/ANO:</strong> {prestacao.pdcMesAno}</p>
                                <p style={{ color: '#000', marginTop: '10px' }}><strong>RECEITAS:</strong> R$ {prestacao.pdcReceitas}</p>
                                <p style={{ color: '#000', marginTop: '10px' }}><strong>RENDIMENTOS:</strong> R$ {prestacao.pdcRendimentos}</p>
                                <p style={{ color: '#000', marginTop: '10px' }}><strong>DESPESAS:</strong> R$ {prestacao.pdcDespesas}</p>
                                <p style={{ color: '#000', marginTop: '10px' }}><strong>FECHAMENTO:</strong> R$ {prestacao.pdcFechamento}</p>
                                <br />
                                <div style={{ color: '#000', marginTop: '10px', width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                                    {prestacao.pdcExtrato && (
                                        <button className="buttonGridPadrao2" onClick={(e) => { e.stopPropagation(); handleExibirPDF(prestacao); }
                                        }>
                                            Extrato
                                        </button>
                                    )}
                                    <Link to={`/Lancamentos/${prestacao.IdPrestacaoDeContas}`} onClick={(e) => e.stopPropagation()}>
                                        <button className="buttonGridPadrao">
                                            Lançamentos
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        ))
                    : (
                    <table>
                        <thead>
                            <tr>
                                <th className='tdAlignCenter'>
                                CÓD
                                </th>
                                <th className='tdAlignLeft'>
                                MÊS/ANO
                                </th>
                                <th className='tdAlignLeft'>
                                RECEITAS
                                </th>
                                <th className='tdAlignLeft'>
                                RENDIMENTOS
                                </th>
                                <th className='tdAlignLeft'>
                                DESPESAS
                                </th>
                                <th className='tdAlignLeft'>
                                FECHAMENTO
                                </th>
                                <th className='tdAlignCenter'>
                                STATUS
                                </th>
                                <th className='tdAlignCenter'>
                                EXTRATO
                                </th>
                                <th className='tdAlignCenter'>
                                
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                        {
                        isLoadingMOD ? <tr><td colSpan="5" style={{ width: "100%", textAlign: "center"}}><CircularProgress /></td></tr> :
                        prestacoes
                        .filter(val => {
                            if (searchTerm === '') {
                                //return val
                                if(sessionStorage.selectStatusRegistro !== undefined && sessionStorage.selectStatusRegistro === '99')
                                {
                                    return val
                                }
                                else if (sessionStorage.selectStatusRegistro !== undefined && sessionStorage.selectStatusRegistro !== '99')
                                {
                                    if(parseInt(sessionStorage.selectStatusRegistro) === parseInt(val.pdcStatus))
                                    {
                                    return val
                                    }
                                }
                                else{
                                    return val
                                }
                            } 
                            else if (
                                val.pdcMes
                                .toLowerCase()
                                .includes(searchTerm.toLowerCase()) 
                                ||
                                val.pdcAno
                                .toLowerCase()
                                .includes(searchTerm.toLowerCase()) 
                                ||
                                val.pdcObservacoes
                                .toLowerCase()
                                .includes(searchTerm.toLowerCase()) 
                                ||
                                val.pdcMesAno
                                .toLowerCase()
                                .includes(searchTerm.toLowerCase())
                            ) {
                                if(sessionStorage.selectStatusRegistro !== undefined && sessionStorage.selectStatusRegistro === '99')
                                {
                                    return val
                                }
                                else if (sessionStorage.selectStatusRegistro !== undefined && sessionStorage.selectStatusRegistro !== '99')
                                {
                                    if(parseInt(sessionStorage.selectStatusRegistro) === parseInt(val.pdcStatus))
                                    {
                                    return val
                                    }
                                }
                                else{
                                    return val
                                }
                            }
                        })
                        .map(prestacao => (
                            <tr key={prestacao.IdPrestacaoDeContas}>{/* onClick={() => handleEditCadastro(prestacao)}>*/}
                                <td className='tdAlignCenter' onClick={() => handleEditCadastro(prestacao)}>
                                    {prestacao.IdPrestacaoDeContas}
                                </td>

                                <td style={{
                                    textTransform: 'uppercase'
                                }} onClick={() => handleEditCadastro(prestacao)}>
                                    {prestacao.pdcMesAno}
                                </td>

                                <td style={{
                                    textTransform: 'uppercase'
                                }} onClick={() => handleEditCadastro(prestacao)}>
                                    R$ {prestacao.pdcReceitas}
                                </td>

                                <td style={{
                                    textTransform: 'uppercase'
                                }} onClick={() => handleEditCadastro(prestacao)}>
                                    R$ {prestacao.pdcRendimentos}
                                </td>

                                <td style={{
                                    textTransform: 'uppercase'
                                }} onClick={() => handleEditCadastro(prestacao)}>
                                    R$ {prestacao.pdcDespesas}
                                </td>

                                <td style={{
                                    textTransform: 'uppercase'
                                }} onClick={() => handleEditCadastro(prestacao)}>
                                    R$ {prestacao.pdcFechamento}
                                </td>

                                <td width={40} className='tdAlignCenter' onClick={() => handleEditCadastro(prestacao)}
                                >
                                    <label className="btnMGUPermissoes" >
                                    <input
                                        type="checkbox"
                                        defaultChecked={!!prestacao.pdcStatus}
                                        disabled
                                    />
                                    {/* <span className="checkmark"></span> */}
                                    </label>
                                </td>

                                <td width={40} className='tdAlignCenter' 
                                    onClick={prestacao.pdcExtrato 
                                    ? () => handleExibirPDF(prestacao) : null}>
                                        {prestacao.pdcExtrato ? 
                                        <button className="buttonGridPadrao2" >
                                            Extrato
                                        </button> : ''}
                                </td>

                                <td className='tdAlignCenter'>
                                    <Link to={`/Lancamentos/${prestacao.IdPrestacaoDeContas}`}>
                                        <button className="buttonGridPadrao">
                                            Lançamentos
                                        </button>
                                    </Link>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    )
                }
                </div>
                {/* <div>
                    <Calendar />
                </div> */}
                {/*                 
                <div className="calbody">
                    <div class="calendar-container">
                        <div class="calendar-header">
                            <button id="prevMonth">Anterior</button>
                            <h1 id="monthYear">Mês Ano</h1>
                            <button id="nextMonth">Próximo</button>
                        </div>
                        <div class="calendar-weekdays">
                            <div>Dom</div>
                            <div>Seg</div>
                            <div>Ter</div>
                            <div>Qua</div>
                            <div>Qui</div>
                            <div>Sex</div>
                            <div>Sáb</div>
                        </div>
                        <div class="calendar-grid" id="calendarGrid">
                        </div>
                    </div>
                    <script src="script.js"></script>
                </div> 
                */}

            </main>
        </div>
        
    )
}

export default Prestacoes;